import { useSelector } from "react-redux";
import { AppAndState, getCurrentAppAndState, RootState } from "store/types";
import { useAppID } from "./use-app-id";

export function useBuilderSelector<T>(
    selector: (state: RootState) => T,
    equalityFn?: ((left: T, right: T) => boolean) | undefined
): T {
    return useSelector(selector, equalityFn);
}

export function useCurrentAppAndStateSelector<T>(
    selector: (state: AppAndState) => T,
    equalityFn?: ((left: T | undefined, right: T | undefined) => boolean) | undefined
): T | undefined {
    const appID = useAppID();
    return useBuilderSelector(s => {
        const currentAppAndState = getCurrentAppAndState(appID, s.apps);
        if (currentAppAndState === undefined) return undefined;

        return selector(currentAppAndState);
    }, equalityFn);
}
